export type BackgroundProcessStatus = 'PENDING' | 'PROCESSING' | 'SUCCESS' | 'FAILED';

export const BACKGROUND_PROCESS_STATUSES: BackgroundProcessStatus[] = [
  'PENDING',
  'PROCESSING',
  'SUCCESS',
  'FAILED',
];

export type AdminBackgroundProcess = {
  id: string;
  processName: string;
  status: BackgroundProcessStatus;
  statusMessage: string;
  createdAt: string;
  updatedAt: string;
};

export type AdminBackgroundProcessDetail = AdminBackgroundProcess & {
  extraDetails: Record<string, unknown> | null;
};
